module.exports = "h1 {\n  margin: 0; }\n"